//import getParents from '../utils/getParents'

const initMenuMobile = (options) => {
  let navigations = [...document.querySelectorAll('.nav--main-nav')]



  for (let nav of navigations) {

    //on init:
    const allCurrentMenu = [...nav.querySelectorAll('.nav__wrap--current')]
    if (allCurrentMenu) {
      //setNavHeight(nav, allCurrentMenu.pop() )
    }

    const buttons = [...nav.querySelectorAll('.nav__toggle, .nav__back-link')]

    buttons.forEach(button => {
      button.addEventListener('click', () => { menuNavigation(button, nav) }, false)
    })

  }

  function menuNavigation(button, nav) {
    if (window.innerWidth < (options?.menuBreakpoint ?? 1200)) {

      const targetId = button.getAttribute('aria-controls')
      const tagetElement = document.getElementById(targetId)
      const isExpanded = Boolean(button.ariaExpanded === 'true') ?? true

      if (tagetElement) {


        const siblings = [...document.querySelectorAll(`[aria-controls="${targetId}"]`)]
        siblings.map(e => e.ariaExpanded = isExpanded ? 'false' : 'true')

        //update classes of target Element
        if (isExpanded) {
          //close it
          tagetElement.classList.remove('nav__wrap--current')
          setTimeout(() => {
            tagetElement.classList.remove('nav__wrap--visible')
          }, 250);
        } else {
          //open it
          //tagetElement.classList.add('nav__wrap--visible','nav__wrap--current')
          tagetElement.classList.add('nav__wrap--visible')
          setTimeout(() => {
            tagetElement.classList.add('nav__wrap--current')
          }, 10);
        }


      }


    }
  }

  function setNavHeight(navigation, tagetElement) {
    if (tagetElement) {
      //console.log(tagetElement, tagetElement.offsetHeight);
      navigation.style.setProperty('--nav-height', tagetElement.offsetHeight + 'px')
    } else {
      navigation.style.removeProperty('--nav-height')
    }
  }

  function setFocus(tagetElement) {
    //console.log(tagetElement);
    if (tagetElement) {
      setTimeout(() => {
        tagetElement.focus({ focusVisible: true })
      }, 250);
    }

  }


}


export default initMenuMobile